module.exports = __webpack_public_path__ + "img/full1-min.9edf42a7.png";